import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { startInvestorAccreditationMutation } from '../../../apollo';
import VerificationForm from './VerificationForm';
import AccountForm from '../AccountForm';
import QualificationIncomplete from './QualificationIncomplete';

const InvestorVerification = (props) => {
  const { accreditationType } = props;

  if (
    accreditationType === 'INDIVIDUAL' ||
    accreditationType === 'INSTITUTION' ||
    accreditationType === 'ACCREDITED_OPTION' ||
    accreditationType === 'OTHER_ENTITIES' ||
    accreditationType === 'NONE_OF_THE_ABOVE'
  ) {
    return (
      <AccountForm
        title='Investor Verification'
        Form={VerificationForm}
        mutation={startInvestorAccreditationMutation}
        {...props}
      />
    );
  }
  return <QualificationIncomplete {...props} />;
};

InvestorVerification.propTypes = {
  accreditationType: PropTypes.string,
};

InvestorVerification.defaultProps = {
  accreditationType: undefined,
};

const mapStateToProps = ({ investorUser }) => ({
  accreditationType: investorUser.accreditationType,
});

export default connect(mapStateToProps)(InvestorVerification);



// WEBPACK FOOTER //
// ./src/components/Account/InvestorVerification/index.js